@if (measureUnit == 1) {
  <span>{{ "GENERAL.PIECES" | translate }}</span>
}
@if (measureUnit == 2) {
  <span>{{ "GENERAL.METERS" | translate }}</span>
}
@if (measureUnit == 3) {
  <span>{{ "GENERAL.LITERS" | translate }}</span>
}
@if (measureUnit == 4) {
  <span>{{ "GENERAL.SACKS" | translate }}</span>
}
@if (measureUnit == 5) {
  <span>{{ "GENERAL.KG" | translate }}</span>
}
@if (measureUnit == 6) {
  <span>{{ "GENERAL.BOXES" | translate }}</span>
}
